var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotesIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1BE00",
    d: "M14 0v8l-6 6h6H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C67401",
    d: "M8 8h6l-6 6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesIndicator);
export default __webpack_public_path__ + "static/media/notes-indicator.0c8c41cffafa2fe3f69a51144d18409d.svg";
export { ForwardRef as ReactComponent };